import { render } from "./CustomModal.vue?vue&type=template&id=d870ff62"
import script from "./CustomModal.vue?vue&type=script&lang=js"
export * from "./CustomModal.vue?vue&type=script&lang=js"
script.render = render

export default script